<template>
  <section>
    <cursoHeader></cursoHeader>
    <div class="bg-white border border-gray my2 p2">
      <div v-show="$dados.PERGUNTA.IDEXERCICIO">
        <div v-show="$dados.RESPONDIDA">
          <h2 class="m1">
            <span
              v-show="$dados.RESULTADO.PONTOSOBTIDOS"
              class="p1 bg-green white"
            >
              Parabéns! Você acertou!
            </span>
            <div
              v-show="!$dados.RESULTADO.PONTOSOBTIDOS"
              class="p1 bg-red white"
            >
              Ops! Você errou :(
              <br /><strong>Aprenda com esse erro! Essa é a chave do sucesso.</strong>
            </div>
          </h2>
        </div>
        <h3 v-show="!$dados.RESPONDIDA || ($route.name !== 'COMPLETE-PERGUNTA')">
          <span
            v-show="$dados.RESPONDIDA && ($route.name === 'ASSERTIVAS-PERGUNTA')"
            style="display:inline-block;font-size:1.2em;"
            :class="vf.class"
          >
            {{vf.title}}:
          </span>
          {{$dados.PERGUNTA.ENUNCIADO}}
        </h3>
        <div v-show="$dados.RESPONDIDA">
          <resultadoDaReposta :refresh='refresh'></resultadoDaReposta>
        </div>
        <div v-show="!$dados.RESPONDIDA">
          <div class="table-container table-theme-1 my3">
            <table>
              <tbody>
                <tr
                  @click="selecionarAlternativa(alternativa)"
                  class="pointer"
                  v-for="alternativa in alternativas"
                  :key="alternativa.resposta"
                >
                  <td style="text-align: left">
                    <p class="m2">{{alternativa.title}}</p>
                    <span
                      v-show="alternativa.resposta == $dados.RESPOSTA"
                      class="btn btn-primary mx4"
                      @click="confirmarResposta()"
                    >
                      <i class="material-icons">check</i> confirmar resposta
                    </span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <div>
            <span
              class="btn mx1"
              @click="voltar()"
            >
              <i class="material-icons">arrow_back</i> voltar
            </span>
            <span
              class="btn mx1"
              @click="refresh()"
            >
              <i class="material-icons">refresh</i> pular
            </span>
          </div>
        </div>
      </div>
      <div v-show="$dados.RODADA.QTDEEXERCICIOS === $dados.RODADA.QTDERESPOSTAS">
        <h2 class="m1">Parabéns! Você concluiu o ciclo {{$dados.RODADA.RODADA}}de exercícios</h2>
        <resumoDeRodadas></resumoDeRodadas>
        <div class="my3">
          <menuBotoes></menuBotoes>
        </div>
      </div>
    </div>
    <div style="text-align: right">
      <span v-show="$dados.PERGUNTA.IDEXERCICIO">
        {{$dados.PERGUNTA.IDEXERCICIO}}
      </span>
    </div>
  </section>
</template>

<script>
import apresentacaoDoExercicio from '@/custom/apresentacaoDoExercicio'
import cursoHeader from '@/custom/cursoHeader'
import menuBotoes from '@/custom/menuBotoes'
import resultadoDaReposta from '@/custom/resultadoDaReposta'
import resumoDeRodadas from '@/custom/resumoDeRodadas'
var componentDefinition = {
  components: { apresentacaoDoExercicio, cursoHeader, menuBotoes, resultadoDaReposta, resumoDeRodadas },
  props: ['alternativas'],
  computed: {
    vf: function () {
      if (this.$dados.RESPOSTA === 1) {
        return {
          class: 'green--text',
          title: 'Verdadeiro'
        }
      } else {
        return {
          class: 'red--text',
          title: 'Falso'
        }
      }
    }
  },
  methods: {
    selecionarAlternativa: function (alternativa) {
      this.$dados.set({
        RESPOSTA: alternativa.resposta
      })
    },
    confirmarResposta: function () {
      var name = this.$route.name.split('-')
      // /ALUNO/:idusuario/MATRICULA/:idalunoscursos/ASSERTIVAS/:idexercicio/PERGUNTA/:idalunosexercicios/RESPOSTA/:resposta
      var endpoint = [
        '/SATACS/ALUNO',
        this.$route.params.idaluno,
        'MATRICULA',
        this.$route.params.idmatricula,
        name[0],
        this.$dados.PERGUNTA.IDEXERCICIO,
        name[1],
        this.$dados.PERGUNTA.IDALUNOSEXERCICIOS,
        'RESPOSTA',
        this.$dados.RESPOSTA
      ].join('/')
      this.$requests.post(endpoint).then(response => {
        var resultado = response.data
        var rodadas = this.$dados.RODADAS
        var rodada = {}
        for (var index = 0; index < rodadas.length; ++index) {
          rodada = rodadas[index]
          if (rodada.RODADA === (this.$route.params.rodada * 1)) {
            ++rodada.QTDERESPOSTAS
            rodada.ACERTOS += resultado.PONTOSOBTIDOS
            rodada.ERROS += resultado.PONTOSOBTIDOS < 1 ? 1 : 0
            rodada.APROVEITAMENTO = Math.ceil(rodada.ACERTOS / rodada.QTDERESPOSTAS) * 100
            rodada.SITUACAO = rodada.QTDERESPOSTAS === rodada.QTDEEXERCICIOS ? 'Completo' : 'Em Andamento'
            break
          }
        }
        this.$dados.set({
          RESPONDIDA: true,
          RESULTADO: resultado
        })
      })
    },
    refresh: function () {
      this.resposta = 0
      var params = this.$route.params
      params.refresh = (params.refresh || 0) * 1
      ++params.refresh
      this.$router.replace({
        name: this.$route.name,
        params: params
      })
    },
    voltar: function () {
      var params = this.$route.params
      params.refresh = null
      this.$router.replace({
        name: this.$route.name.split('-')[0],
        params: params
      })
    }
  }
}
export default componentDefinition
</script>
